var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "177px",
    viewBox: "0 0 214 177",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-5---History",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.6--History---empty-state",
    transform: "translate(-646.000000, -225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(647.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document",
    transform: "translate(10.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.210084,93.1543696 C195.210084,41.7075401 153.409876,0 101.848739,0 C50.2876029,0 8.48739496,41.7075401 8.48739496,93.1543696 C8.48739496,106.862035 11.4796261,119.864056 16.8058908,131.580547 L186.891588,131.580547 C192.217853,119.864056 195.210084,106.862035 195.210084,93.1543696",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,131.580547 L5.09243697,131.580547",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.907563,131.580547 L202,131.580547",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1848739,131.580547 L191.815126,131.580547",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(49.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.205479,114.929577 C111.205479,117.730382 88.9500483,120 61.5,120 C34.0467958,120 11.7945205,117.730382 11.7945205,114.929577 C11.7945205,112.128773 34.0467958,109.859155 61.5,109.859155 C88.9500483,109.859155 111.205479,112.128773 111.205479,114.929577",
    id: "Fill-9",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,70.9859155 L122.987404,7.88419405 C122.987404,3.53051643 119.435239,0 115.051717,0 L7.93253796,0 C3.55216467,0 0,3.53051643 0,7.88419405 L0.0125963286,70.9859155 L123,70.9859155 Z",
    id: "Fill-11",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9308362,70.9859155 L87.6164384,0 L7.96225723,0 C3.56547287,0 0,3.53051643 0,7.88419405 L0.0126435208,70.9859155 L15.9308362,70.9859155 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,70.9859155 L123,86.7605634 C123,91.1173709 119.447472,94.6478873 115.060351,94.6478873 L7.9333504,94.6478873 C3.55252849,94.6478873 0,91.1173709 0,86.7605634 L0,70.9859155 L123,70.9859155 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,70.9859155 L123,86.7605634 C123,91.1173709 119.447472,94.6478873 115.060351,94.6478873 L7.9333504,94.6478873 C3.55252849,94.6478873 0,91.1173709 0,86.7605634 L0,70.9859155 L123,70.9859155 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7123288,83.6619718 C65.7123288,85.9959759 63.8301533,87.8873239 61.5,87.8873239 C59.1731898,87.8873239 57.2876712,85.9959759 57.2876712,83.6619718 C57.2876712,81.3313213 59.1731898,79.4366197 61.5,79.4366197 C63.8301533,79.4366197 65.7123288,81.3313213 65.7123288,83.6619718",
    id: "Fill-19",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7123288,83.6619718 C65.7123288,85.9959759 63.8301533,87.8873239 61.5,87.8873239 C59.1731898,87.8873239 57.2876712,85.9959759 57.2876712,83.6619718 C57.2876712,81.3313213 59.1731898,79.4366197 61.5,79.4366197 C63.8301533,79.4366197 65.7123288,81.3313213 65.7123288,83.6619718 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "80.8767123 111.549296 40.4383562 111.549296 42.460274 96.3380282 78.8547945 96.3380282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "80.8767123 111.549296 40.4383562 111.549296 42.460274 96.3380282 78.8547945 96.3380282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6438356,111.549296 L92.6712329,111.549296",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,70.9859155 L122.987404,7.88419405 C122.987404,3.53051643 119.435239,0 115.051717,0 L7.93253796,0 C3.55216467,0 0,3.53051643 0,7.88419405 L0.0125963286,70.9859155 L123,70.9859155 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(84.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.0144623,85.5 L5.99773284,85.5 C2.69897978,85.5 0,82.8069054 0,79.5153453 L0,20.1176471 L100.012195,20.1176471 L100.012195,79.5153453 C100.012195,82.8069054 97.3132153,85.5 94.0144623,85.5",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0144623,85.5 L5.99773284,85.5 C2.69897978,85.5 0,82.8069054 0,79.5153453 L0,20.1176471 L100.012195,20.1176471 L100.012195,79.5153453 C100.012195,82.8069054 97.3132153,85.5 94.0144623,85.5 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.012195,20.1176471 L0,20.1176471 L0,5.83120205 C0,2.62404092 2.69897978,0 5.99773284,0 L94.0144623,0 C97.3132153,0 100.012195,2.62404092 100.012195,5.83120205 L100.012195,20.1176471 Z",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.012195,20.1176471 L0,20.1176471 L0,5.83120205 C0,2.62404092 2.69897978,0 5.99773284,0 L94.0144623,0 C97.3132153,0 100.012195,2.62404092 100.012195,5.83120205 L100.012195,20.1176471 Z",
    id: "Stroke-33",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5609756,10.0588235 C13.5609756,11.9102302 12.0427359,13.4117647 10.1707317,13.4117647 C8.29872747,13.4117647 6.7804878,11.9102302 6.7804878,10.0588235 C6.7804878,8.20741688 8.29872747,6.70588235 10.1707317,6.70588235 C12.0427359,6.70588235 13.5609756,8.20741688 13.5609756,10.0588235",
    id: "Fill-35",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5609756,10.0588235 C13.5609756,11.9102302 12.0427359,13.4117647 10.1707317,13.4117647 C8.29872747,13.4117647 6.7804878,11.9102302 6.7804878,10.0588235 C6.7804878,8.20741688 8.29872747,6.70588235 10.1707317,6.70588235 C12.0427359,6.70588235 13.5609756,8.20741688 13.5609756,10.0588235 Z",
    id: "Stroke-37",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1219512,10.0588235 C27.1219512,11.9102302 25.6037116,13.4117647 23.7317073,13.4117647 C21.8597031,13.4117647 20.3414634,11.9102302 20.3414634,10.0588235 C20.3414634,8.20741688 21.8597031,6.70588235 23.7317073,6.70588235 C25.6037116,6.70588235 27.1219512,8.20741688 27.1219512,10.0588235",
    id: "Fill-39",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1219512,10.0588235 C27.1219512,11.9102302 25.6037116,13.4117647 23.7317073,13.4117647 C21.8597031,13.4117647 20.3414634,11.9102302 20.3414634,10.0588235 C20.3414634,8.20741688 21.8597031,6.70588235 23.7317073,6.70588235 C25.6037116,6.70588235 27.1219512,8.20741688 27.1219512,10.0588235 Z",
    id: "Stroke-41",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6829268,10.0588235 C40.6829268,11.9102302 39.1646872,13.4117647 37.2926829,13.4117647 C35.4206787,13.4117647 33.902439,11.9102302 33.902439,10.0588235 C33.902439,8.20741688 35.4206787,6.70588235 37.2926829,6.70588235 C39.1646872,6.70588235 40.6829268,8.20741688 40.6829268,10.0588235",
    id: "Fill-43",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6829268,10.0588235 C40.6829268,11.9102302 39.1646872,13.4117647 37.2926829,13.4117647 C35.4206787,13.4117647 33.902439,11.9102302 33.902439,10.0588235 C33.902439,8.20741688 35.4206787,6.70588235 37.2926829,6.70588235 C39.1646872,6.70588235 40.6829268,8.20741688 40.6829268,10.0588235 Z",
    id: "Stroke-45",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6164723,55.3235294 L32.9688936,55.3235294 C31.612796,55.3235294 30.5121951,54.2350384 30.5121951,52.8938619 L30.5121951,44.3414322 C30.5121951,43.0002558 31.612796,41.9117647 32.9688936,41.9117647 L41.6164723,41.9117647 C42.9725698,41.9117647 44.0731707,43.0002558 44.0731707,44.3414322 L44.0731707,52.8938619 C44.0731707,54.2350384 42.9725698,55.3235294 41.6164723,55.3235294",
    id: "Fill-47",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6164723,55.3235294 L32.9688936,55.3235294 C31.612796,55.3235294 30.5121951,54.2350384 30.5121951,52.8938619 L30.5121951,44.3414322 C30.5121951,43.0002558 31.612796,41.9117647 32.9688936,41.9117647 L41.6164723,41.9117647 C42.9725698,41.9117647 44.0731707,43.0002558 44.0731707,44.3414322 L44.0731707,52.8938619 C44.0731707,54.2350384 42.9725698,55.3235294 41.6164723,55.3235294 Z",
    id: "Stroke-49",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3481796,55.3235294 L56.7006009,55.3235294 C55.3445034,55.3235294 54.2439024,54.2350384 54.2439024,52.8938619 L54.2439024,44.3414322 C54.2439024,43.0002558 55.3445034,41.9117647 56.7006009,41.9117647 L65.3481796,41.9117647 C66.7042771,41.9117647 67.804878,43.0002558 67.804878,44.3414322 L67.804878,52.8938619 C67.804878,54.2350384 66.7042771,55.3235294 65.3481796,55.3235294",
    id: "Fill-51",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3481796,55.3235294 L56.7006009,55.3235294 C55.3445034,55.3235294 54.2439024,54.2350384 54.2439024,52.8938619 L54.2439024,44.3414322 C54.2439024,43.0002558 55.3445034,41.9117647 56.7006009,41.9117647 L65.3481796,41.9117647 C66.7042771,41.9117647 67.804878,43.0002558 67.804878,44.3414322 L67.804878,52.8938619 C67.804878,54.2350384 66.7042771,55.3235294 65.3481796,55.3235294 Z",
    id: "Stroke-53",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3847649,55.3235294 L78.7371863,55.3235294 C77.3810887,55.3235294 76.2804878,54.2350384 76.2804878,52.8938619 L76.2804878,44.3414322 C76.2804878,43.0002558 77.3810887,41.9117647 78.7371863,41.9117647 L87.3847649,41.9117647 C88.7433192,41.9117647 89.8414634,43.0002558 89.8414634,44.3414322 L89.8414634,52.8938619 C89.8414634,54.2350384 88.7433192,55.3235294 87.3847649,55.3235294",
    id: "Fill-55",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3847649,55.3235294 L78.7371863,55.3235294 C77.3810887,55.3235294 76.2804878,54.2350384 76.2804878,52.8938619 L76.2804878,44.3414322 C76.2804878,43.0002558 77.3810887,41.9117647 78.7371863,41.9117647 L87.3847649,41.9117647 C88.7433192,41.9117647 89.8414634,43.0002558 89.8414634,44.3414322 L89.8414634,52.8938619 C89.8414634,54.2350384 88.7433192,55.3235294 87.3847649,55.3235294 Z",
    id: "Stroke-57",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6164723,75.4411765 L32.9688936,75.4411765 C31.612796,75.4411765 30.5121951,74.3526854 30.5121951,73.011509 L30.5121951,64.4590793 C30.5121951,63.1179028 31.612796,62.0294118 32.9688936,62.0294118 L41.6164723,62.0294118 C42.9725698,62.0294118 44.0731707,63.1179028 44.0731707,64.4590793 L44.0731707,73.011509 C44.0731707,74.3526854 42.9725698,75.4411765 41.6164723,75.4411765",
    id: "Fill-59",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6164723,75.4411765 L32.9688936,75.4411765 C31.612796,75.4411765 30.5121951,74.3526854 30.5121951,73.011509 L30.5121951,64.4590793 C30.5121951,63.1179028 31.612796,62.0294118 32.9688936,62.0294118 L41.6164723,62.0294118 C42.9725698,62.0294118 44.0731707,63.1179028 44.0731707,64.4590793 L44.0731707,73.011509 C44.0731707,74.3526854 42.9725698,75.4411765 41.6164723,75.4411765 Z",
    id: "Stroke-61",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3481796,75.4411765 L56.7006009,75.4411765 C55.3445034,75.4411765 54.2439024,74.3526854 54.2439024,73.011509 L54.2439024,64.4590793 C54.2439024,63.1179028 55.3445034,62.0294118 56.7006009,62.0294118 L65.3481796,62.0294118 C66.7042771,62.0294118 67.804878,63.1179028 67.804878,64.4590793 L67.804878,73.011509 C67.804878,74.3526854 66.7042771,75.4411765 65.3481796,75.4411765",
    id: "Fill-63",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3481796,75.4411765 L56.7006009,75.4411765 C55.3445034,75.4411765 54.2439024,74.3526854 54.2439024,73.011509 L54.2439024,64.4590793 C54.2439024,63.1179028 55.3445034,62.0294118 56.7006009,62.0294118 L65.3481796,62.0294118 C66.7042771,62.0294118 67.804878,63.1179028 67.804878,64.4590793 L67.804878,73.011509 C67.804878,74.3526854 66.7042771,75.4411765 65.3481796,75.4411765 Z",
    id: "Stroke-65",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3847649,75.4411765 L78.7371863,75.4411765 C77.3810887,75.4411765 76.2804878,74.3526854 76.2804878,73.011509 L76.2804878,64.4590793 C76.2804878,63.1179028 77.3810887,62.0294118 78.7371863,62.0294118 L87.3847649,62.0294118 C88.7433192,62.0294118 89.8414634,63.1179028 89.8414634,64.4590793 L89.8414634,73.011509 C89.8414634,74.3526854 88.7433192,75.4411765 87.3847649,75.4411765",
    id: "Fill-67",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3847649,75.4411765 L78.7371863,75.4411765 C77.3810887,75.4411765 76.2804878,74.3526854 76.2804878,73.011509 L76.2804878,64.4590793 C76.2804878,63.1179028 77.3810887,62.0294118 78.7371863,62.0294118 L87.3847649,62.0294118 C88.7433192,62.0294118 89.8414634,63.1179028 89.8414634,64.4590793 L89.8414634,73.011509 C89.8414634,74.3526854 88.7433192,75.4411765 87.3847649,75.4411765 Z",
    id: "Stroke-69",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2750088,33.5294118 L12.6274302,33.5294118 C11.2713326,33.5294118 10.1707317,32.4409207 10.1707317,31.0997442 L10.1707317,29.2531969 C10.1707317,27.9120205 11.2713326,26.8235294 12.6274302,26.8235294 L21.2750088,26.8235294 C22.6311064,26.8235294 23.7317073,27.9120205 23.7317073,29.2531969 L23.7317073,31.0997442 C23.7317073,32.4409207 22.6311064,33.5294118 21.2750088,33.5294118",
    id: "Fill-71",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2750088,33.5294118 L12.6274302,33.5294118 C11.2713326,33.5294118 10.1707317,32.4409207 10.1707317,31.0997442 L10.1707317,29.2531969 C10.1707317,27.9120205 11.2713326,26.8235294 12.6274302,26.8235294 L21.2750088,26.8235294 C22.6311064,26.8235294 23.7317073,27.9120205 23.7317073,29.2531969 L23.7317073,31.0997442 C23.7317073,32.4409207 22.6311064,33.5294118 21.2750088,33.5294118 Z",
    id: "Stroke-73",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3125091,33.5294118 L33.0411494,33.5294118 C31.6451667,33.5294118 30.5121951,32.4409207 30.5121951,31.0997442 L30.5121951,29.2531969 C30.5121951,27.9120205 31.6451667,26.8235294 33.0411494,26.8235294 L87.3125091,26.8235294 C88.7110208,26.8235294 89.8414634,27.9120205 89.8414634,29.2531969 L89.8414634,31.0997442 C89.8414634,32.4409207 88.7110208,33.5294118 87.3125091,33.5294118",
    id: "Fill-75",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3125091,33.5294118 L33.0411494,33.5294118 C31.6451667,33.5294118 30.5121951,32.4409207 30.5121951,31.0997442 L30.5121951,29.2531969 C30.5121951,27.9120205 31.6451667,26.8235294 33.0411494,26.8235294 L87.3125091,26.8235294 C88.7110208,26.8235294 89.8414634,27.9120205 89.8414634,29.2531969 L89.8414634,31.0997442 C89.8414634,32.4409207 88.7110208,33.5294118 87.3125091,33.5294118 Z",
    id: "Stroke-77",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1707317,41.9117647 L23.7317073,41.9117647",
    id: "Stroke-79",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1707317,48.6176471 L23.7317073,48.6176471",
    id: "Stroke-81",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1707317,55.3235294 L23.7317073,55.3235294",
    id: "Stroke-83",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1707317,62.0294118 L23.7317073,62.0294118",
    id: "Stroke-85",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1707317,68.7352941 L23.7317073,68.7352941",
    id: "Stroke-87",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1707317,75.4411765 L18.6463415,75.4411765",
    id: "Stroke-89",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 42.000000)",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99329127,10.0661972 L4.99329127,1.41220369e-13",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.84217094e-14,5.03346334 L9.98947751,5.03346334",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(22.020298, 57.465212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38773819,6.76061321 L3.38773819,0",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.3803066 L6.77547639,3.3803066",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(194.794946, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38773819,6.76061321 L3.38773819,0",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.3803066 L6.77547639,3.3803066",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(184.631732, 82.817512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38773819,6.76061321 L3.38773819,0",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.3803066 L6.77547639,3.3803066",
    id: "Stroke-69"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.1486265,0.221896096 C35.7644741,-0.0739653654 35.2325709,-0.0739653654 34.8513735,0.221896096 C31.4767429,2.81219338 27.395863,4.62962808 22.9278757,5.27267391 C22.3959724,5.34814877 22,5.81609292 22,6.36554992 L22,16.0112374 C22,24.9504801 27.3515377,32.682125 35.09073,35.9184871 C35.3507716,36.027171 35.6462734,36.027171 35.90927,35.9184871 C43.6425523,32.682125 49,24.9534991 49,16.0112374 L49,6.36253092 C49,5.81307392 48.6040276,5.34814877 48.0691693,5.27267391 C43.604137,4.62962808 39.5262121,2.81219338 36.1486265,0.221896096 Z",
    id: "Stroke-125",
    stroke: "#7450C8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.2c44270323087336be406ccd95465a60.svg";
export { ForwardRef as ReactComponent };